import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/Success.svg'


const _hoisted_1 = { class: "modal PhoneVerificationModal" }
const _hoisted_2 = { class: "modal--content" }
const _hoisted_3 = { class: "modal--content-body" }
const _hoisted_4 = { class: "HeadingtextinfoDv" }
const _hoisted_5 = { class: "btninfoDv" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "modal--backdrop",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.dismiss()))
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[2] || (_cache[2] = _createElementVNode("figure", { class: "twoFaImg" }, [
          _createElementVNode("img", {
            src: _imports_0,
            alt: ""
          })
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h2", null, _toDisplayString(_ctx.$t("setting.twoFactorAuth.success.title")), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t("setting.twoFactorAuth.success.description", {
                phone: _ctx.userData,
              })), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            class: "btn btn--primary",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.dismiss()))
          }, _toDisplayString(_ctx.$t("setting.twoFactorAuth.success.doneButton")), 1)
        ])
      ])
    ])
  ]))
}